module.exports = __webpack_public_path__ + "img/message_11.754a2c08.png";